export const VISITOR = {
  LIVE: '/report/live-visitor',
  COUNTRY_WISE: '/report/visitor-by-country',
  CITY_WISE: '/report/visitor-by-city',
  PAGE: '/report/visitor-by-page',
  DEVICE: '/report/visitor-by-device',
  VISITOR_SUMMARY: '/report/visitor-summary',
}
